module.exports = __webpack_public_path__ + "img/bcbhCover.8b28126c.png";